var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.$t('tooltip.regenerateGameCode')),expression:"$t('tooltip.regenerateGameCode')"}],staticClass:"btn btn-sm btn-warning",on:{"click":function($event){return _vm.generateCode()}}},[_c('i',{staticClass:"fa fa-undo"})])
}
var staticRenderFns = []

export { render, staticRenderFns }